"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _basic = _interopRequireDefault(require("./_basic"));
class PGSqlApi extends _basic.default {
  /**
   * Represents a Tables Api.
   * @constructor
   * @param {Function} param0.userTokenFactory Function that returns access token
   * @param {String} param0.PGSqlUrl Url of api
   * @param {Function} param0.accountIdFactory Function that returns accountId for cross account requests
   * @param {Number} param0.timeout Request timeout in ms
   * @param {Function} param0.log Log function to log queries. for exmaple console.log
   * @param {String} param0.feature Feature name for development
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      PGSqlUrl,
      accountIdFactory,
      timeout,
      log,
      feature
    } = _ref;
    super({
      userTokenFactory,
      accountIdFactory
    });
    this.PGSqlUrl = PGSqlUrl;
    this.axios = _axios.default.create({
      ...(timeout && {
        timeout
      })
    });
    this.log = log;
    this.feature = feature;
  }
  async _callApi(_ref2) {
    let {
      url,
      data,
      method,
      params = {}
    } = _ref2;
    if (this.log) this.log(data);
    if (this.feature && this.feature !== 'master') params.feature = this.feature;
    const {
      data: res
    } = await this.axios({
      url: `${this.PGSqlUrl}/${this.accountIdFactory}/${url}`,
      method,
      data,
      params,
      headers: {
        Authorization: this.userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).catch(e => {
      const response = _lodash.default.get(e, 'response.data', e);
      const err = new Error(response.message);
      err.data = response;
      throw err;
    });
    return res;
  }

  /**
   * @param {String} param0.query cypher query for graph db
   * @param {Object} param0.params Object with params to query 
   * @param {String} param0.database Database name
   * @param {Boolean} param0.isExternal is database external
   */
  async executeQuery(_ref3) {
    let {
      query,
      params,
      database,
      isExternal = false
    } = _ref3;
    return this._callApi({
      data: {
        query,
        params,
        database,
        isExternal
      },
      method: 'post',
      url: 'query'
    });
  }

  /**
   * 
   * @returns {Array} database names
   */
  async listDatabases() {
    const {
      databases
    } = await this._callApi({
      method: 'get',
      url: 'databases'
    });
    return databases;
  }

  /**
   * 
   * @param {String} param0.database database name
   */
  async createDatabase(_ref4) {
    let {
      database,
      externalCredentials
    } = _ref4;
    return this._callApi({
      data: {
        database,
        externalCredentials
      },
      method: 'put',
      url: 'databases'
    });
  }

  /**
   * 
   * @param {String} param0.database database name
   */
  async getDatabaseInfo(_ref5) {
    let {
      database
    } = _ref5;
    return this._callApi({
      method: 'get',
      url: `databases/${encodeURIComponent(database)}`
    });
  }

  /**
   * 
   * @param {String} param0.database database name
   * @param {Boolean} param0.isExternal is database external
  */
  async dropDatabase(_ref6) {
    let {
      database,
      isExternal
    } = _ref6;
    return this._callApi({
      data: {
        database,
        isExternal
      },
      method: 'delete',
      url: 'databases'
    });
  }

  /**
   * 
   * @param {String} param0.database database name
   * @param {String} param0.schema schema name. default public
   * @param {Boolean} param0.isExternal is database external
   * @returns ['table_name']
   */
  async listTables(_ref7) {
    let {
      database,
      schema = 'public',
      isExternal
    } = _ref7;
    const {
      rows
    } = await this.executeQuery({
      query: `SELECT table_name FROM information_schema.tables 
      WHERE table_schema = '${schema}'
      and table_type = 'BASE TABLE';`,
      database,
      isExternal
    });
    return rows.map(x => x.table_name);
  }

  /**
   * 
   * @param {String} param0.database database name
   * @param {Boolean} param0.isExternal is database external
   * @returns ['schema_name']
   */
  async listSchemas(_ref8) {
    let {
      database,
      isExternal
    } = _ref8;
    const {
      rows
    } = await this.executeQuery({
      query: `SELECT schema_name FROM information_schema.schemata 
        where schema_name not in ('pg_catalog', 'information_schema')`,
      database,
      isExternal
    });
    return rows.map(x => x.schema_name);
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {Boolean} param0.isExternal is database external
   */
  async createSchema(_ref9) {
    let {
      database,
      schema,
      isExternal
    } = _ref9;
    return this.executeQuery({
      query: `create schema ${schema};`,
      database,
      isExternal
    });
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {Boolean} param0.isExternal is database external
   */
  async dropSchema(_ref10) {
    let {
      database,
      schema,
      isExternal
    } = _ref10;
    return this.executeQuery({
      query: `drop schema ${schema} cascade;`,
      database,
      isExternal
    });
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {Boolean} param0.isExternal is database external
   */
  async dropTable(_ref11) {
    let {
      database,
      schema,
      table,
      isExternal
    } = _ref11;
    return this.executeQuery({
      query: `drop table ${schema}.${table};`,
      database,
      isExternal
    });
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {Array} param0.columns [{name:"col",type:"integer"}]
   * @param {String} param0.primaryKey comma separated list of columns for primary key
   * @param {Boolean} param0.isExternal is database external
   * 
   */
  async createTable(_ref12) {
    let {
      database,
      schema,
      table,
      columns,
      primaryKey,
      isExternal
    } = _ref12;
    return this.executeQuery({
      query: `create table ${schema}.${table} (${columns.map(x => `${x.name} ${x.type}`).join(', ')}, primary key (${primaryKey}));`,
      database,
      isExternal
    });
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {Array} param0.columns [{name:"col",type:"integer"}]
   * @param {Boolean} param0.isExternal is database external
   */
  async addColumns(_ref13) {
    let {
      database,
      schema,
      table,
      columns,
      isExternal
    } = _ref13;
    return this.executeQuery({
      query: `alter table ${schema}.${table} ${columns.map(x => `add column ${x.name} ${x.type}`).join(', ')};`,
      database,
      isExternal
    });
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {Array} param0.rows [{}]
   * @param {Integer} param0.chunkSize divide array into chunks to make small payload
   * @param {Object} param0.context {progress} to watch progress of insert will be set from 0 to 100
   * @param {Boolean} param0.isExternal is database external
   */
  async insert(_ref14) {
    let {
      database,
      schema,
      table,
      rows,
      chunkSize = 300,
      context,
      isExternal
    } = _ref14;
    const res = [];
    if (!_lodash.default.isArray(rows)) rows = [rows];
    const allKeys = {};
    rows.forEach(x => Object.assign(allKeys, x));
    const keys = Object.keys(allKeys);
    const stringifyRow = row => `${keys.map(key => this.encodeValue(row[key])).join(', ')}`;
    // eslint-disable-next-line no-unused-vars
    for (const [index, chunk] of _lodash.default.chunk(rows, chunkSize).entries()) {
      const query = `insert into  ${schema}.${table} (${keys.join(', ')})
values (${chunk.map(stringifyRow).join('), (')});`;
      res.push(await this.executeQuery({
        query,
        database,
        isExternal
      }));
      if (context) context.progress = (index + 1) / (rows.length / chunkSize) * 100;
    }
    return res;
  }

  /**
   * 
   * @param {*} value any value to encode and paste to pg query
   */
  // eslint-disable-next-line class-methods-use-this
  encodeValue(value) {
    if (_lodash.default.isUndefined(value) || value === '' || _lodash.default.isNull(value)) return 'NULL';
    if (_lodash.default.isString(value)) return `'${value.replaceAll("'", "''")}'`;
    if (_lodash.default.isNumber(value) || _lodash.default.isBoolean(value)) return value;
    return `'${JSON.stringify(value).replaceAll("'", "''")}'`;
  }

  /**
   * 
   * @param {String} param0.database database name
   * @param {String} param0.query example: select * from table. query must be select only, without limit and offset
   * @param {Integer} param0.chunkSize size of chunk to export data
   * @param {Object} param0.context {progress, total} to watch progress of select will be set from 0 to 100
   * @param {Object} param0.params Object with params to query 
   * @param {Number} param0.offset offset to start with
   * @param {Number} param0.limit total limit of records to return
   * @param {Boolean} param0.isExternal is database external
   * @returns {Array} array of query results
   */
  async selectAll(_ref15) {
    let {
      database,
      query,
      context,
      chunkSize = 1000,
      offset = 0,
      limit,
      isExternal,
      params
    } = _ref15;
    let count,
      rows,
      result = [];
    if (limit && limit < chunkSize) {
      chunkSize = limit;
    }
    if (context) {
      const {
        rows
      } = await this.executeQuery({
        query: `select count(*) from (${query}) x`,
        database,
        isExternal,
        params
      });
      count = rows[0].count;
      // eslint-disable-next-line require-atomic-updates
      context.total = count;
    }
    do {
      rows = (await this.executeQuery({
        query: `${query} offset ${offset} limit ${chunkSize}`,
        database,
        isExternal,
        params
      })).rows;
      offset += chunkSize;
      result = result.concat(rows);
      if (context) {
        // eslint-disable-next-line require-atomic-updates
        context.progress = Math.min(offset / count * 100, 100);
      }
      if (result.length >= limit) {
        result = result.slice(0, limit);
        break;
      }
    } while (rows.length === chunkSize);
    return result;
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {Boolean} param0.isExternal is database external
   * @returns {String} id,id2 comma-separated list of primary keys
   */

  async getPrimaryKeys(_ref16) {
    let {
      database,
      schema,
      table,
      isExternal
    } = _ref16;
    const query = `SELECT string_agg(a.attname, ', ') AS pk
        FROM
            pg_constraint AS c
            CROSS JOIN LATERAL UNNEST(c.conkey) AS cols(colnum) -- conkey is a list of the columns of the constraint; so we split it into rows so that we can join all column numbers onto their names in pg_attribute
            INNER JOIN pg_attribute AS a ON a.attrelid = c.conrelid AND cols.colnum = a.attnum
        WHERE
            c.contype = 'p' -- p = primary key constraint
            AND c.conrelid = '${schema}.${table}'::REGCLASS;`;
    const {
      rows
    } = await this.executeQuery({
      database,
      query,
      isExternal
    });
    return rows[0].pk;
  }

  /**
   * 
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {String} param0.key key to update
   * @param {*} param0.value value to set
   * @param {Object} param0.row row object {id, col1,col2...} need to get primary key value
   * @param {String} param0.primaryKeys comma-separated list of primary keys
   * @param {Boolean} param0.isExternal is database external
   */
  async editRow(_ref17) {
    let {
      database,
      schema,
      table,
      key,
      value,
      row,
      primaryKeys,
      isExternal
    } = _ref17;
    value = this.encodeValue(value);
    const pk = primaryKeys.split(',').map(x => _lodash.default.trim(x));
    return this.executeQuery({
      database,
      query: `update ${schema}.${table} 
set ${key} = ${value}
where ${pk.map(primaryKey => `${primaryKey} = ${this.encodeValue(row[primaryKey])}`).join(' AND ')}`,
      isExternal
    });
  }

  /**
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {String} param0.primaryKeys comma separated list of primary keys
   * @param {Array} param0.rows array of rows to delete
   * @param {Boolean} param0.isExternal is database external
  */
  async deleteRows(_ref18) {
    let {
      database,
      schema,
      table,
      rows,
      primaryKeys,
      isExternal
    } = _ref18;
    const pk = primaryKeys.split(',').map(x => _lodash.default.trim(x));
    return this.executeQuery({
      database,
      query: `delete from ${schema}.${table} 
where (${rows.map(row => `${pk.map(primaryKey => `${primaryKey} = ${this.encodeValue(row[primaryKey])}`).join(' AND ')}`).join(') \nOR (')})`,
      isExternal
    });
  }

  /**
   * @description generate create table query for existing table
   * @param {String} param0.schema schema name
   * @param {String} param0.database database name
   * @param {String} param0.table table name
   * @param {Boolean} param0.isExternal is database external
   * @returns {String} code to create table
  */
  async generateTableSchema(_ref19) {
    let {
      database,
      schema,
      table,
      isExternal
    } = _ref19;
    const {
      rows
    } = await this.executeQuery({
      database,
      query: `SELECT 'CREATE TABLE ' || '${schema}.${table}' || ' (' || '\n' || '' || 
        string_agg(column_list.column_expr, ', ' || '\n' || '') || 
        '' || ',\n' || 'PRIMARY KEY (' || (SELECT string_agg(a.attname, ', ') AS pk
    FROM
        pg_constraint AS c
        CROSS JOIN LATERAL UNNEST(c.conkey) AS cols(colnum) -- conkey is a list of the columns of the constraint; so we split it into rows so that we can join all column numbers onto their names in pg_attribute
        INNER JOIN pg_attribute AS a ON a.attrelid = c.conrelid AND cols.colnum = a.attnum
    WHERE
        c.contype = 'p' -- p = primary key constraint
        AND c.conrelid = '${schema}.${table}'::REGCLASS limit 1) || '));'  code
    FROM (
      SELECT '    ' || column_name || ' ' || data_type || 
           coalesce('(' || character_maximum_length || ')', '') || 
           case when is_nullable = 'YES' then '' else ' NOT NULL' end as column_expr
      FROM information_schema.columns
      WHERE table_schema = '${schema}' AND table_name = '${table}'
      ORDER BY ordinal_position)  column_list;`,
      isExternal
    });
    return rows[0].code;
  }

  /**
   * 
   * @returns {Object} used size and limit in MB {"usedSize":179,"sizeLimit":200}
   */
  async getDBSize() {
    return this._callApi({
      url: 'size'
    });
  }
}
var _default = PGSqlApi;
exports.default = _default;